import React from 'react'
import { BASE_URL, USER_TOKEN } from '../../../Utils/constant'

import useRefreshToken from '../../../Hooks/usegenerateToken.js'
import IssuerDash from './Issuer/IssuerDash'
import { useSelector } from "react-redux";
import VerifierDash from './Verifier/VerifierDash';
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';
import TopTitleBar from './TopTitleBar.js';
import { useNavigate } from 'react-router-dom';

export default function Home({ ISSUER_ID }) {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const User = useSelector(state => state.User)
    const navigate = useNavigate();
    return (
        User.user_type === 'Issuer' ? <>
            <SlideUpWrapper direction={'slide-down'}>
                <div className='breadcrumb mt-1'>
                   
                    <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton1'> <img className='homeIcon' alt="" src="/home.svg" style={{width:"20px", height:"20px"}} />Dashboard</span></h2></TopTitleBar>
                    {/* <button className='btn btn-primary' style={{width:"18%", height:"12%", marginBottom:"18px", fontSize:"15px"}} onClick={()=>navigate('../credentials/issue-credentials')}>Issue New document</button> */}
                    
                </div>
                {/* <Breadcrumb pos={1} title={'Dashboard'} category={'issuer'} /> */}
                <IssuerDash />
            </SlideUpWrapper>
        </> : User.user_type === 'Verifier' ? <VerifierDash id={User.id} /> : null
    )
}
